const translateHereResponse = (geocodeResponse) => {
    // Check that the payload is not empty, and that there is at least one
    // position. If these checks are moved to variables, TypeScript does not
    // do the same flow analysis and considers the same values to be possibly
    // null.
    if (geocodeResponse.payload == null ||
        !geocodeResponse.payload?.some((item) => item.position != undefined)) {
        return [];
    }
    const { payload: items } = geocodeResponse;
    const dataToAutocomplete = [];
    for (const item of items) {
        if (item.position == undefined) {
            continue;
        }
        const entry = {
            point: item.position,
            friendlyName: item.title,
            addressToTrack: item.address,
        };
        dataToAutocomplete.push({
            optionLabels: [item.title],
            inputLabel: item.title,
            value: { entry, responseFrom: 'here' },
            isRecentSearch: false,
        });
    }
    return dataToAutocomplete;
};

export { translateHereResponse as default };
//# sourceMappingURL=hereToAutocomplete.js.map
